import { contentWidth } from '~/dims'

export default {
    container: { width: contentWidth, flexShrink: 1 }
}



// WEBPACK FOOTER //
// ./src/views/Products/ProductSummary/styles.js